import React, { useContext } from 'react'
import { PropertyCardContext } from '../context'
import { Price } from '../../..'

export const FooterPrice = () => {
  const { price, variant, property, isSmallCardVariant } = useContext(PropertyCardContext)
  const nights = isSmallCardVariant ? undefined : property?.nights?.value

  if (!price) return null

  let align: 'end' | 'start' = 'end'

  if (variant === 'lite' || isSmallCardVariant) {
    align = 'start'
  }

  return (
    <div data-testid="footer-price">
      <Price price={price} align={align} hideDiscountTag nights={nights} />
    </div>
  )
}
FooterPrice.displayName = 'FooterPrice'
